import { useQuery } from 'react-query';

import { getCacheSettings } from 'common/helpers';
import { QUERY_KEYS } from 'consts/queryKeys';
import { getReservationTypeOfService } from 'modules/_common/api';

export const useQueryReservationTypeOfService = (
  providedProductType: string | null | undefined,
  enabled: boolean | undefined,
) => {
  const { isLoading, error, data } = useQuery(
    QUERY_KEYS.UNITS_RESERVATION_TYPE_OF_SERVICE,
    () => getReservationTypeOfService(providedProductType),
    {
      ...getCacheSettings(),
      enabled: enabled ?? false,
    },
  );

  return {
    loading: isLoading,
    error: error,
    typeOfServiceData: data,
  };
};
